// Документация роутера: https://github.com/thepassle/app-tools/blob/master/router/README.md

import { html } from 'lit';

if (!(globalThis as any).URLPattern) {
  await import('urlpattern-polyfill');
}

import { Router } from '@thepassle/app-tools/router.js';
import { t } from './i18n';

// @ts-ignore
import { title } from '@thepassle/app-tools/router/plugins/title.js';

import './pages/app-roll.js';
import './pages/app-history.js';
import './pages/app-settings.js';

const baseURL: string = (import.meta as any).env.BASE_URL;

export const router = new Router({
  routes: [
    {
      path: resolveRouterPath(),
      title: 'Кубики',
      render: () => html`<app-roll></app-roll>`,
    },
    {
      path: resolveRouterPath('history'),
      title: 'История кубиков',
      render: () => html`<app-history></app-history>`,
    },
    {
      path: resolveRouterPath('settings'),
      title: 'Настройки кубиков',
      render: () => html`<app-settings></app-settings>`,
    },
  ],
});

/**
 * Разрешает маршрутный путь относительно базового URL приложения.
 * @param unresolvedPath Относительный путь (например, 'history')
 * @returns Полный путь с учётом BASE_URL
 */
export function resolveRouterPath(unresolvedPath?: string): string {
  let resolvedPath = baseURL;
  if (unresolvedPath) {
    resolvedPath = resolvedPath + unresolvedPath;
  }
  return resolvedPath;
}

/** Возвращает локализованный заголовок для текущего маршрута. */
export function getRouteTitle(pathname = window.location.pathname): string {
  if (pathname === resolveRouterPath('history')) return t('headerHistory');
  if (pathname === resolveRouterPath('settings')) return t('headerSettings');
  return t('headerRoll');
}
